import React from "react";
import { renderArticleImage } from "../../pages/Home/NewsArticle";
import { convertToWords, htmlExcerpt } from "../../modules/string-tools";
import { Link } from "react-router-dom";

const ArticleSegment = ({ item }) => {
  return (
    <Link to={{ pathname: item.link }} className="block">
      <div className="flex text-black items-start py-4 border-b border-light-grey">
        <div className="w-24 h-24 mr-4 flex-shrink-0 border border-grey-md">
          <span className="text-sm flex items-center justify-center h-full">
            {renderArticleImage(item.img, false)}
          </span>
        </div>

        <div className="flex flex-col justify-between">
          <h4
            className="font-bold text-lg mb-2"
            dangerouslySetInnerHTML={{ __html: item.title }}
          />
          {item.type && (
            <span
              className={
                "bg-dark-grey text-white uppercase text-xxs inline-block p-1 rounded self-start"
              }
            >
              {convertToWords(item.type)}
            </span>
          )}
          <div className="mt-2 text-xs">
            <div
              dangerouslySetInnerHTML={{
                __html: htmlExcerpt(item.content, 100),
              }}
            />{" "}
            <p className="mt-2 font-bold underline uppercase text-xs text-black">
              Read more
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ArticleSegment;
